import { Injectable } from '@angular/core';
import { AppService } from '@alfresco/aca-shared';

@Injectable()
export class WkAppShellService extends AppService {
  public hideSidenavConditions: string[] = [];
}
